module.exports = require("@cdm-logger/server");